import { ipcRenderer } from './Electron';
import CordovaUtils from './Cordova';
var SecureStorageHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     */
    function SecureStorageHelpers() {
        /**Storage object */
        this.Storage = null;
        return;
    }
    /**
     * Open and store object to secure storage
     * @param {string} clientId App client id
     * @returns {Promise<any>} Promise of type any
     */
    SecureStorageHelpers.prototype.OpenSecureStorage = function (clientId, isNative) {
        var that = this;
        this.ClientId = clientId;
        return new Promise(function (resolve) {
            if (isNative) {
                !CordovaUtils.IsElectron ?
                    that.Storage = new window["cordova"].plugins.SecureStorage(function () {
                        resolve();
                    }, function (error) {
                        console.error("Error " + error);
                        resolve();
                    }, "SS-" + clientId)
                    :
                        resolve();
            }
            else {
                resolve();
            }
        });
    };
    /**
     * Get value from storage
     * @param {string} key Key of the object to get
     */
    SecureStorageHelpers.prototype.Get = function (key) {
        var that = this;
        return new Promise(function (resolve, reject) {
            if (!CordovaUtils.IsElectron) {
                that.Storage.get(function (value) {
                    resolve(value);
                }, function (error) {
                    console.error("Error " + error);
                    reject();
                }, key);
            }
            else {
                var res = ipcRenderer.sendSync('get-password', that.ClientId, key);
                res === null ? reject() : resolve(res);
            }
        });
    };
    /**
     * Store object into secure storage
     * @param {string} value Value to store
     * @param {string} key Object key identifier
     * @returns {Promise<any>} Promise of type any
     */
    SecureStorageHelpers.prototype.Store = function (value, key) {
        var that = this;
        return new Promise(function (resolve, reject) {
            if (!CordovaUtils.IsElectron) {
                that.Storage.set(function (_key) {
                    resolve();
                }, function (error) {
                    console.error("Error " + error);
                    reject();
                }, key, value);
            }
            else {
                ipcRenderer.sendSync('set-password', that.ClientId, key, value) ? resolve() : reject();
            }
        });
    };
    /**
     * Remove object from secure storage
     * @param {string} key Key of the object to remove
     * @returns {Promise<any>} Promise of type any
     */
    SecureStorageHelpers.prototype.Remove = function (key) {
        var that = this;
        return new Promise(function (resolve) {
            if (!CordovaUtils.IsElectron) {
                that.Storage.remove(function (_key) {
                    resolve();
                }, function (_error) {
                    console.error("Error " + _error);
                    resolve();
                }, key);
            }
            else {
                ipcRenderer.sendSync('delete-password', that.ClientId, key);
                resolve();
            }
        });
    };
    /**
     * Remove all entries from the secure storage
     * @param {Array<string>} keys of keys to delete (applies to electron only)
     * @returns {Promise<any>} Promise of boolean. True if cleared OK, false on error.
     */
    SecureStorageHelpers.prototype.ClearStorage = function (keys) {
        if (keys === void 0) { keys = null; }
        var that = this;
        return new Promise(function (resolve) {
            if (keys === null) {
                that.Storage.clear(function () {
                    resolve(true);
                }, function (error) {
                    resolve(false);
                });
            }
            else {
                keys.forEach(function (key) {
                    ipcRenderer.sendSync('delete-password', that.ClientId, key);
                });
                resolve(true);
            }
        });
    };
    return SecureStorageHelpers;
}());
var SecureStorage = new SecureStorageHelpers();
export default SecureStorage;
//# sourceMappingURL=SecureStorage.js.map